import ActiveController from '@/controller.active';

class bookingController extends ActiveController{
  constructor(
    $auth,
    $bookings
  ){
    'ngInject';
    super();
    this.$auth = $auth;
    this.$bookings = $bookings;
    this.ready = false;
  }

  $onInit() {
    this.$bookings.init().then(() => this.ready = true);
  }

  $onDelete( id ){
    this.$bookings.destroy( id );
  }

  get mode() {
    return this.$bookings.mode;
  }
}

export default bookingController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking.controller.js
 **/